import type { MedicalHistoryConfig } from 'config-types/config/medical-history';

const MEDICAL_HISTORY_DATA: MedicalHistoryConfig = {
  medicalConditions: {
    quickPicks: [
      { display: 'Arthritis' },
      { display: 'Blood Disorder' },
      { display: 'Cancer' },
      { display: 'Diabetes' },
      { display: 'Gastrointestinal' },
      { display: 'Genitourinary' },
      { display: 'Heart Disorders' },
      { display: 'High Blood Pressure' },
      { display: 'High Cholesterol' },
      { display: 'Kidney Disorders' },
      { display: 'Liver Disorders, Hepatitis' },
      { display: 'Lung Disorders' },
      { display: 'Musculoskeletal Diseases' },
      { display: 'Neurological' },
      { display: 'Psychiatric' },
      { display: 'Sexually Transmitted Diseases' },
      { display: 'Skin Disorders' },
      { display: 'Thyroid' },
      { display: 'Diabetes type 2', code: 'E11.9' },
      { display: 'Diabetes Type 1', code: 'E10.9' },
      { display: 'High Blood pressure', code: 'i10' },
      { display: 'Heart Disease', code: 'I51.9' },
      { display: 'Elevated Cholesterol', code: 'E78.5' },
      { display: 'Asthma', code: 'J45.909' },
      { display: 'COPD', code: 'J44.9' },
      { display: 'Back Pain', code: 'M54.50' },
      { display: 'HypoThyroid', code: 'E03.9' },
      { display: 'Gout', code: 'M10.9' },
      { display: 'Arthritis', code: 'M19.90' },
    ],
  },
  allergies: {
    quickPicks: [],
  },
  medications: {
    quickPicks: [
      { name: 'Toradol', strength: '60 mg', id: 10098 },
      { name: 'Toradol', strength: '30 mg', id: 81146 },
      { name: 'Decadron', strength: '8 mg', id: 39039 },
      { name: 'Decadron', strength: '4 mg', id: 39038 },
      { name: 'Rocephin', strength: '1 g', id: 30900 },
      { name: 'Rocephin', strength: '500 mg', id: 30901 },
    ],
  },
  inHouseMedications: {
    quickPicks: [
      {
        name: 'Dexamethasone',
        dose: 8,
        units: 'mg',
        route: '78421000',
        dosespotId: 39039,
      },
      {
        name: 'Ketorolac',
        dose: 60,
        units: 'mg',
        route: '78421000',
        dosespotId: 7272,
      },
      {
        name: 'Ceftriaxone',
        dose: 1,
        units: 'g',
        route: '78421000',
        dosespotId: 25270,
      },
      {
        name: 'Ceftriaxone',
        dose: 500,
        units: 'mg',
        route: '78421000',
        dosespotId: 30901,
      },
      {
        name: 'Ondansetron',
        dose: 4,
        units: 'mg',
        route: '78421000',
        dosespotId: 14094,
      },
      {
        name: 'Cefazolin',
        dose: 1,
        units: 'g',
        route: '78421000',
        dosespotId: 10052,
      },
      {
        name: 'Cleocin Phosphate',
        dose: 300,
        units: 'mg',
        route: '78421000',
        dosespotId: 1447,
      },
      {
        name: 'Ipratropium Bromide/Albuterol 3 mg solution',
        dose: 3,
        units: 'mg',
        route: '447694001',
        dosespotId: 12514,
      },
      {
        name: 'Triamcinolone',
        dose: 40,
        units: 'mg',
        route: '78421000',
        dosespotId: 77520,
      },
      {
        name: 'Clonidine',
        dose: 0.1,
        units: 'mg',
        route: '26643006',
        dosespotId: 40344,
      },
      {
        name: 'Aspirin',
        dose: 325,
        units: 'mg',
        route: '26643006',
        dosespotId: 11256,
      },
      {
        name: 'Nitroglycerin',
        dose: 0.4,
        units: 'mg',
        route: '26643006',
        dosespotId: 29928,
      },
    ],
  },
};

export const MEDICAL_HISTORY_CONFIG = Object.freeze(MEDICAL_HISTORY_DATA);
